import {
  B2BCheckoutContext,
  initialState,
} from './../context/B2BCheckoutContext';
import {
  B2BCheckoutContextState,
  OrdersForUpdation,
  OrdersForValidationAndUpdationCheckout,
} from '../types';
import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {useContext, useReducer} from 'react';

const reducer = {
  setOrders: function (
    state: B2BCheckoutContextState,
    action: PayloadAction<OrdersForValidationAndUpdationCheckout>,
  ) {
    state.ordersForUpdation = action?.payload?.ordersForUpdation ?? [];
    state.ordersForValidation = action.payload?.ordersForValidation ?? [];
  },
  updateOnVerification: function (
    state: B2BCheckoutContextState,
    action: PayloadAction<OrdersForUpdation[]>,
  ) {
    state.ordersForValidation = [
      // ...(state.ordersForValidation ?? []),
      ...(action.payload ?? []),
    ];
  },
};

const slice = createSlice({
  initialState,
  name: 'B2BCheckout',
  reducers: reducer,
});

export function useB2BCheckoutReducer() {
  const B2BCheckoutReducer = useReducer(slice.reducer, initialState);
  return B2BCheckoutReducer;
}

export function useB2BCheckoutContext() {
  return useContext(B2BCheckoutContext);
}

export const B2BCheckoutActionsLocal = slice.actions;
